const types = {
  //Get Template name
  GET_CRM_START: "GET_CRM_START",
  GET_CRM_SUCCESS: "GET_CRM_SUCCESS",
  GET_CRM_ERROR: "GET_CRM_ERROR",
  GET_CRM_RESET: "GET_CRM_RESET",

  //Create Template name
  CREATE_CRM_START: "CREATE_CRM_START",
  CREATE_CRM_SUCCESS: "CREATE_CRM_SUCCESS",
  CREATE_CRM_ERROR: "CREATE_CRM_ERROR",
  CREATE_CRM_RESET: "CREATE_CRM_RESET",

  //delete Template name
  DELETE_CRM_START: "DELETE_CRM_START",
  DELETE_CRM_SUCCESS: "DELETE_CRM_SUCCESS",
  DELETE_CRM_ERROR: "DELETE_CRM_ERROR",
  DELETE_CRM_RESET: "DELETE_CRM_RESET",

  //update Template name
  UPDATE_CRM_START: "UPDATE_CRM_START",
  UPDATE_CRM_SUCCESS: "UPDATE_CRM_SUCCESS",
  UPDATE_CRM_ERROR: "UPDATE_CRM_ERROR",
  UPDATE_CRM_RESET: "UPDATE_CRM_RESET",

  //single item  name
  SINGLE_CRM_START: "SINGLE_CRM_START",
  SINGLE_CRM_SUCCESS: "SINGLE_CRM_SUCCESS",
  SINGLE_CRM_ERROR: "SINGLE_CRM_ERROR",
  SINGLE_CRM_RESET: "SINGLE_CRM_RESET",
};

export default types;
